
export default function Billing() {
  return <div>Billing Settings</div>;
}
